import React, { useState, useRef, useEffect } from 'react';
import moment from "moment";
import toast from 'react-hot-toast';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import RightArrow from '../../../assets/images/RightArrow.svg';
import Loader from '../../../component/common/Loader.js';
import { capitalizeFirstLetter, errorToast, getLocalStorageItem, successToast } from '../../../utils/helper.js';
import { Calendar } from 'react-calendar';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import InputWithLabel from '../../../component/common/InputWithLabel.jsx';
import { Api } from '../../../api';
import { taskFeatureList } from '../../../utils/constants.js';
import { ApiForRole } from './ApiForRole.js';

const initialDetailFormData = {
  // _id: null,
  challenge_title: '',
  image: '',
  image: null,
  start_date: moment(new Date()).format('YYYY-MM-DD'),
  end_date: moment(new Date()).add(1, 'days').format('YYYY-MM-DD')
};

const AddDetails = ({ setData, setAllData, setNewChallenge, newChallenge }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const [imagePreview, setImagePreview] = useState('');
  const [selectedImage, setSelectedImage] = useState('');
  const [loader, setloader] = useState(false);
  const [challengeDescription, setChallengeDescription] = useState('');
  const startCalendarRef = useRef();
  const endCalendarRef = useRef();
  const fileInputRef = useRef();
  const [searchParams] = useSearchParams();
  const queryparams = Object.fromEntries(searchParams);
  const view = queryparams.view || 'edit';
  const [formData, setFormData] = useState(initialDetailFormData);

    useEffect(() => {
      const queryParams = new URLSearchParams(location.search);
      const newChallengeParam = queryParams.get("newchallenge");
      setNewChallenge(newChallengeParam);
    }, [location.search]);

  const handleImageChange = (e) => {
    if (e?.target?.files[0]?.size > 1048576) {
      errorToast(`File size should be less than 1MB`);
    } else {
      if (e?.target?.files[0]) {
        if (!e?.target?.files[0].name.match(/\.(jpg|jpeg|png|gif)$/i)) {
          errorToast(
            `The specified file ${e?.target?.files[0].name} could not be uploaded. Please upload valid image.`
          );
        } else {
          // console.log('image', e.target.files[0]);
          setSelectedImage(e.target.files[0]);
          const objectUrl = URL.createObjectURL(e.target.files[0]);
          setFormData((prev) => ({
            ...prev,
            image: objectUrl,
            image: e.target.files[0]
          }));
          setImagePreview(objectUrl);
          return () => URL.revokeObjectURL(objectUrl);
        }
      } else {
        setImagePreview(undefined);
      }
    }
  };

  const convertBackendTasks = (badge) => {
    if (!badge) return [];

    const backendTasks = badge || [];

    const groupedTasks = [];

    backendTasks.forEach((task) => {
      const matchedFeature = taskFeatureList.find((item) => item.backendName === task.feature);

      if (!matchedFeature) return;

      const group = matchedFeature.groubedBy;

      const convertMinutesToHoursAndMins = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  
  return {
    hours: hours.toString().padStart(2, '0'),
    mins: mins.toString().padStart(2, '0')
  };
};

const { hours, mins } = convertMinutesToHoursAndMins(task.duration);

      const subTask = {
        id: task._id,
        title: task.title,
        description: task.description,
        instruction: task.instruction,
        number_of_tries: task.number_of_tries,
        backend_name: task.feature,
        feature: matchedFeature.name,
        status: task.status,
        type_of_task: task.type_of_task,
        duration: task.duration,
        hours: hours, 
        mins: mins,  
        wellpoints: task.wellpoints,
        days : task.days,
        isSubscription : task.isSubscription === true ? 1 : task.isSubscription === false ? 0 : "",
        connect_to_wearable : task.connect_to_wearable === true ? 1 : task.connect_to_wearable === false ? 0 : "",
        wearableConfig: task.wearableConfig || null
      };

      const existingGroup = groupedTasks.find((g) => g.grouped_by === group);
      if (existingGroup) {
        existingGroup.sub_tasks.push(subTask);
      } else {
        groupedTasks.push({
          id: group + '_' + Date.now(), 
          grouped_by: group,
          sub_tasks: [subTask]
        });
      }
    });

    return {
      tasks: groupedTasks
    };
  };
  const handleContinueDetails =  async() => {

     if (!formData?.challenge_title || !challengeDescription || (!formData?.image && !imagePreview)) {
       if (!formData?.challenge_title) toast.error('Challenge title is required');
       else if (!challengeDescription) toast.error('Challenge description is required');
       else if (!formData?.image && !imagePreview) toast.error('Image is required');
       return;
     }

    if(formData?.start_date === formData?.end_date){
    toast.error('Start date and End date can not be same.');
    return;
    }

    // console.log(formData, "formData")
    // setloader(true);
    const isFanMode = JSON.parse(getLocalStorageItem('isB2BFansMode')) || false;
    const reqBody = {
      title: formData?.challenge_title,
      description: challengeDescription,
      startDate: formData?.start_date,
      endDate: formData?.end_date,
      time: selectedTime,
      image: formData?.image || imagePreview,
      isFanMode: isFanMode,
      ...(state?._id && { challenge_id: state._id })
    };
    try {

      // console.log(reqBody,"payload ==>")
      setloader(true);
      const response = await ApiForRole().addChallengesDeyails(reqBody);
        if (response?.status === 200) {
          setFormData(initialDetailFormData);
          setChallengeDescription('');
          successToast(response?.data?.message);
          setSelectedTime('');
          setSelectedImage('');
          navigate(userData?.slug ? `/${userData?.slug}/challenges/create-new-challenges?page=tasks&newchallenge=${newChallenge}` :`/challenges/create-new-challenges?page=tasks&newchallenge=${newChallenge}`, {
            state: {
              _id: response?.data?.challenge?._id,
              imageUrl: response?.data?.challenge?.image || imagePreview
            }
          });
        }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setloader(false);
    }
  };
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const [startDate, setStartDate] = useState(
    new Date(new Date().setFullYear(new Date().getFullYear() + 1))
  );
  const [startDate2, setStartDate2] = useState(new Date());
  const [endDate, setEndDate] = useState(
    new Date(new Date().setFullYear(new Date().getFullYear() + 1))
  );
  const [endDate2, setEndDate2] = useState(() => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
});
  const [isOpenStart, setIsOpenStart] = useState(false);
  const [isOpenEnd, setIsOpenEnd] = useState(false);
 const handleChange = (e) => {
  const { name, value: rawValue } = e.target;
  const value = capitalizeFirstLetter(rawValue);
  setFormData((prev) => ({ ...prev, [name]: value }));
};


  const startDateChange = (date) => {
    setStartDate2(date);
    setIsOpenStart(false);
    const newStartDate = moment(date).format('YYYY-MM-DD');
    // console.log(newStartDate)
    setStartDate(newStartDate);
    setFormData((prev) => ({ ...prev, start_date: newStartDate }));
  };
  const endDateChange = (date) => {
    setEndDate2(date);
    setIsOpenEnd(false);
    const newEndDate = moment(date).format('YYYY-MM-DD');
    setEndDate(newEndDate);
    setFormData((prev) => ({ ...prev, end_date: newEndDate }));
  };
  // Handle clicks outside to close calendars
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideStart =
        startCalendarRef.current && !startCalendarRef.current.contains(event.target);
      const clickedOutsideEnd =
        endCalendarRef.current && !endCalendarRef.current.contains(event.target);

      if (isOpenStart && clickedOutsideStart) {
        setIsOpenStart(false);
      }

      if (isOpenEnd && clickedOutsideEnd) {
        setIsOpenEnd(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpenStart, isOpenEnd]);

  const toggleStartCalendar = () => {
    setIsOpenStart((prev) => {
      if (!prev) setIsOpenEnd(false); 
      return !prev;
    });
  };

  const toggleEndCalendar = () => {
    setIsOpenEnd((prev) => {
      if (!prev) setIsOpenStart(false); 
      return !prev;
    });
  };

  const generateTimes = () => {
    const times = [];
    const start = 0; // 12:00 AM
    const end = 24 * 60 - 30; // 11:30 PM

    for (let time = start; time <= end; time += 30) {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;
      const period = hours >= 12 ? 'pm' : 'am';
      const displayHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
      const displayTime = `${displayHours}:${minutes === 0 ? '00' : minutes} ${period}`;
      times.push(displayTime);
    }

    return times;
  };

  const [isOpenT, setIsOpenT] = useState(false);
  const [selectedTime, setSelectedTime] = useState('');
  const handleTimeToggle = () => {
    setIsOpenT(!isOpenT);
  };
  const handleSelectT = (time) => {
    setSelectedTime(time);
    setIsOpenT(false);
  };

  const fetchList = async (id) => {
    if(localStorage.getItem("email")){
      localStorage.removeItem('email');
    }
    if(localStorage.getItem('department')){
      localStorage.removeItem('department')
    }
    setloader(true);
    try {
      const response = await ApiForRole().getSpecificChallenges(id);
      const responseData = response?.data || {};
      if (responseData) {
        setAllData(responseData);
        const taskModify = convertBackendTasks(responseData?.tasks);
         localStorage.setItem('challengeData', JSON.stringify(responseData))
         localStorage.setItem('challengeStatus', responseData?.status);
         localStorage.setItem('email', JSON.stringify(responseData?.email));
         localStorage.setItem('department',JSON.stringify(responseData?.department))
        setData(taskModify || []);
        const urlToFile = async (url, filename = 'image.jpg') => {
          try {
            const res = await fetch(url);
            const blob = await res.blob();
            return new File([blob], filename, { type: blob.type });
          } catch (error) {
            console.error('Error converting URL to file:', error);
            return null;
          }
        };

        let imageFile = null;
        let imagePreviewUrl = '';

        if (responseData?.image) {
          if (responseData.image.startsWith('http')) {
            // External URL - just use directly for preview
            imagePreviewUrl = responseData.image;
            imageFile = null;
          } else {
            // Local URL - try to convert
            try {
              imageFile = await urlToFile(responseData.image);
              if (imageFile) {
                imagePreviewUrl = URL.createObjectURL(imageFile);
              }
            } catch (error) {
              console.error('Error processing image:', error);
              imagePreviewUrl = responseData.image;
              imageFile = null;
            }
          }
        }

        setSelectedTime(responseData?.time);
        setChallengeDescription(responseData?.description || '');

        setFormData({
          challenge_title: responseData?.title,
          image: imageFile, 
          start_date: new Date(responseData?.startDate),
          end_date: new Date(responseData?.endDate)
        });


        setStartDate2(new Date(responseData?.startDate));
        setEndDate2(new Date(responseData?.endDate));
        setImagePreview(imagePreviewUrl); 
        setSelectedImage(imageFile); 
      }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setloader(false);
    }
  };

  // console.log(formData, "formData")

  useEffect(() => {
    if (state?._id) {
      fetchList(state?._id);
    }
  }, [state?._id]);

  return (
    <div className=" mx-auto max-w-[1640px]">
      {loader ? <Loader /> : null}
      <div className="">
        <div className="flex flex-col w-full mt-5 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8 ">
          <div className="grid lg:gap-5 gap-2 2xl:gap-7 md:grid-cols-[0.5fr_2fr_0.5fr] 2xl:[0.5fr_2fr_0.5fr] grid-cols-1">
            <div>
              <input
                type="file"
                accept=".jpg, .jpeg, .png"
                className="hidden"
                ref={fileInputRef}
                onChange={handleImageChange}
              />

              <div
                onClick={() => fileInputRef.current.click()} 
                className="flex justify-center mt-3 items-center overflow-hidden rounded-[9px] border-[1.5px] border-[#D4D4D4] border-dashed dark:border-shoorah-darkBorder
                               w-[150px] h-[150px]  sm:w-[240px] sm:h-[240px] bg-[#F1F1F1] dark:bg-shoorah-darkBgColor relative cursor-pointer"
              >
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="Selected"
                    className="absolute w-full h-full object-cover rounded-[9px]"
                  />
                ) : (
                  <div className="flex flex-col justify-center items-center">
                    <svg
                      className="mb-2 text-shoorah-primary"
                      width="22"
                      height="22"
                      viewBox="0 0 23 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.89999 20.0445H14.3667C18.9222 20.0445 20.7444 18.2223 20.7444 13.6667V8.20004C20.7444 3.64449 18.9222 1.82227 14.3667 1.82227H8.89999C4.34444 1.82227 2.52222 3.64449 2.52222 8.20004V13.6667C2.52222 18.2223 4.34444 20.0445 8.89999 20.0445Z"
                        fill="#D4D4D4"
                        stroke="#0B0B0B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.90004 9.11124C9.90643 9.11124 10.7223 8.2954 10.7223 7.28902C10.7223 6.28263 9.90643 5.4668 8.90004 5.4668C7.89366 5.4668 7.07782 6.28263 7.07782 7.28902C7.07782 8.2954 7.89366 9.11124 8.90004 9.11124Z"
                        fill="#D4D4D4"
                        stroke="#0B0B0B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                        fill="#D4D4D4"
                      />
                      <path
                        d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                        stroke="#0B0B0B"
                        strokeWidth="1.36667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <h5 className="text-xs font-medium">
                      Drop Image {/*  */}
                      <span className="text-shoorah-primary font-medium"> here</span>
                    </h5>
                  </div>
                )}
              </div>
              {selectedImage && (
                <p className="mt-2 text-xs text-gray-600">
                  Selected: {selectedImage?.name} ({Math.round(selectedImage?.size / 1024)} KB)
                </p>
              )}
            </div>

            <div className="lg:space-y-10 space-y-7 w-full">
              <InputWithLabel
                label={'Challenge Title'}
                placeholder={'Enter Challenge Title'}
                containerClassName={'w-full'}
                onChange={handleChange}
                value={formData?.challenge_title}
                name={'challenge_title'}
                disabled={view === 'preview' || view === 'preview_only'}
              />
              {/* Company Description start */}
              <div className="mt-0 ">
                <h1 className="text-base font-medium my-3">
                  Challenge Description
                </h1>
                <div className="sm:grid sm:grid-cols-12 gap-0 sm:w-[100%] w-full">
                  <div className="col-span-1 sm:col-span-full">
                    <div className="relative">
                      <textarea
                        className={`w-full h-[90px] rounded-lg px-5 py-2 bg-[#F5F5F5] border-[1.5px] ${
                          challengeDescription.length > 500
                            ? 'border-red-500'
                            : challengeDescription.length > 450
                            ? 'border-yellow-500'
                            : 'border-[#E7E8EA]'
                        } text-gray-700 dark:text-gray-300 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder`}
                        placeholder="Enter Challenge Description"
                        value={challengeDescription}
                        onChange={(e) => {
                          const value = capitalizeFirstLetter(e.target.value);
                          setChallengeDescription(value.slice(0, 500));
                        }}
                        maxLength={500}
                      ></textarea>
                      <div
                        className={`text-xs mt-1 text-right ${
                          challengeDescription.length > 500
                            ? 'text-red-500'
                            : challengeDescription.length > 450
                            ? 'text-yellow-500'
                            : 'text-gray-500'
                        }`}
                      >
                        {challengeDescription.length}/500 characters
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* --------------------------------------- */}
        <div className="flex flex-col w-full mt-5 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8 ">
          <div className="flex justify-between items-center mt-6 mb-6">
            <h3 className="font-medium text-xl">Challenge Duration</h3>
          </div>

          <div className="grid lg:gap-5 gap-2 2xl:gap-7 md:grid-cols-4  grid-cols-1">
            <div className="w-full">
              <h2 className="mb-2 text-[16px] font-medium">Start Date</h2>
              <div className="relative w-full">
                <button
                  type="button"
                  onClick={toggleStartCalendar}
                  className="flex flex-row justify-between w-full appearance-none bg-shoorah-normanGray dark:bg-shoorah-darkBgColor text-black dark:text-white rounded-lg px-[15px] border-2 border-shoorah-borderGray dark:border-gray-600 py-2 focus:outline-none"
                >
                  <span> {startDate2 && `${new Date(startDate2).toLocaleDateString()}`}</span>
                  <svg
                    className="mt-1 ml-1 text-black dark:text-white"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M4 6L8 10L12 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>

                {isOpenStart && (
                  <div
                    ref={startCalendarRef}
                    className="absolute sm:-top-2 top-0 md:-left-40 sm:-left-10 ml-24 left-[170px] transform scale-75 z-10 mt-1 sm:p-2 dark:text-white bg-white shadow-lg ring-opacity-5 focus:outline-none divide-y divide-gray-100 rounded-md ring-1 ring-[#E7EAE8] ring-opacity-1 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder dark:ring-opacity-0"
                  >
                    <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                      <Calendar
                        className="calendar text-sm sm:text-lg"
                        onChange={startDateChange}
                        minDate={new Date()}
                        // maxDate={endDate2}
                        value={startDate2}
                        nextLabel={
                          <button className="custom-next-button flex justify-center items-center text-black dark:text-white">
                            <ChevronRightIcon className="w-8 h-8" />
                          </button>
                        }
                        prevLabel={
                          <button className="custom-prev-button flex justify-center items-center text-black dark:text-white">
                            <ChevronLeftIcon className="w-8 h-8" />
                          </button>
                        }
                        navigationLabel={({ date }) => (
                          <button
                            style={{ cursor: 'default', pointerEvents: 'none' }}
                            className="text-base text-black dark:text-white"
                          >
                            {date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                          </button>
                        )}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="w-full">
              <h2 className="mb-2 text-[16px] font-medium">End Date</h2>
              <div className="relative w-full">
                <button
                  type="button"
                  onClick={toggleEndCalendar}
                  className="flex flex-row justify-between w-full appearance-none bg-shoorah-normanGray dark:bg-shoorah-darkBgColor text-black dark:text-white rounded-lg px-[15px] border-2 border-shoorah-borderGray dark:border-gray-600 py-2 focus:outline-none"
                >
                  <span>{endDate2.toLocaleDateString()}</span> 
                  <svg
                    className="mt-1 ml-1 text-black dark:text-white"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M4 6L8 10L12 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>

                {isOpenEnd && (
                  <div
                    ref={endCalendarRef}
                    className="absolute sm:-top-2 top-0 md:-left-40 sm:-left-10 ml-24 left-[170px] transform scale-75 z-10 mt-1 sm:p-2 dark:text-white bg-white shadow-lg ring-opacity-5 focus:outline-none divide-y divide-gray-100 rounded-md ring-1 ring-[#E7EAE8] ring-opacity-1 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder dark:ring-opacity-0"
                  >
                    <div className="bg-white dark:bg-shoorah-darkBgColor text-[14px]">
                      <Calendar
                        className="calendar text-sm sm:text-lg"
                        onChange={endDateChange}
                        value={endDate2}
                        minDate={new Date(new Date(startDate2).setDate(new Date(startDate2).getDate() + 1))}
                        nextLabel={
                          <button className="custom-next-button flex justify-center items-center text-black dark:text-white">
                            <ChevronRightIcon className="w-8 h-8" />
                          </button>
                        }
                        prevLabel={
                          <button className="custom-prev-button flex justify-center items-center text-black dark:text-white">
                            <ChevronLeftIcon className="w-8 h-8" />
                          </button>
                        }
                        navigationLabel={({ date }) => (
                          <button
                            style={{ cursor: 'default', pointerEvents: 'none' }}
                            className="text-base text-black dark:text-white"
                          >
                            {date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                          </button>
                        )}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full">
              <h2 className="mb-2 text-[16px] font-medium">Add Time</h2>
              <div className="h-10 border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder rounded-lg px-4 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor flex flex-col justify-center items-start relative cursor-pointer">
                <div
                  className="w-full h-full flex items-center justify-between text-[14px]"
                  onClick={() => handleTimeToggle()}
                >
                  <p className="flex flex-row justify-between items-center text-[14px] h-fit w-full bg-transparent border-none cursor-pointer text-dark">
                    {selectedTime ? selectedTime : 'Set Time'}
                    <svg
                      className={`w-4 h-4 transform ${isOpenT ? 'rotate-180' : ''}`}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </p>
                </div>

                {isOpenT && (
                  <div className="absolute top-[38px] z-20 w-full mt-2 text-[14px] sm:w-[71%] left-0 sm:left-[29%] overflow-hidden bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder dark:text-shoorah-darkBgTabColor border-[1.5px] border-shoorah-borderGray rounded-xl overflow-y-auto max-h-[200px]">
                    {generateTimes().map((time) => (
                      <div
                        key={time}
                        className=" px-4 sm:px-6 text-[14px] py-2 hover:bg-[#E7E8EA] cursor-pointer dark:bg-shoorah-darkBgColor dark:text-shoorah-darkBg"
                        onClick={() => handleSelectT(time)}
                      >
                        {time}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center w-full gap-4 lg:gap-12">
        <div className="flex gap-4 sm:gap-8"></div>
        <button
          onClick={() => {
            handleContinueDetails();
          }}
          type="button"
          className="btn-primary btn-sm w-full sm:w-auto"
        >
          Continue
          <img className="ml-2" src={RightArrow} alt="edit" />
        </button>
      </div>
    </div>
  );
};
export default AddDetails;
